<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="Connect software you already use to Feedback Link and send review/feedback requests automatically."/>
    <div v-if="disabled" class="text-center">
      <div class="inline-block w-100 my-20">
        <img class="mx-auto w-32" src="@/assets/images/misc/automate.png"/>
        <p class="my-8 font-medium text-lg" > {{ disabledMessage }}</p>
        <vs-button class="w-full" @click="$router.push('/dash/settings/plan')">See Plans</vs-button>
      </div>
    </div>
    <div v-else>
        <h2 class="text-center my-10">Automate review/feedback requests</h2>
        <div class="vx-row justify-center">
          <!-- Developer API available on Growth/Engage (limits.devAPI). When unlocked the
               card routes to the API page; otherwise it shows an upgrade state. -->
          <div class="vx-col w-full lg:w-1/2 mb-base flex" :class="{ 'cursor-pointer': devAPIAllowed }">
              <vx-card v-if="devAPIAllowed" class="p-5 text-center" @click="() => {$router.push('/dash/getfeedback/automate/developers')}">
                <img src="@/assets/images/misc/code.png"  class="w-32 mx-auto"/>
                <h2 class="my-6">Developer API</h2>
                <p class="text-lg my-5">Automatically schedule or send requests for reviews/feedback to customers by integrating your systems manually.</p>
                <vs-divider/>
                <p class="mt-4">Targeted towards developers - programming skills required.</p>
              </vx-card>
              <vx-card v-else class="p-5 text-center">
                <img src="@/assets/images/misc/code.png"  class="w-32 mx-auto"/>
                <h2 class="my-6">Developer API</h2>
                <p class="text-lg my-5">Automatically schedule or send requests for reviews/feedback to customers by integrating your systems manually.</p>
                <vs-divider/>
                <p class="my-4 font-medium">Available on the Growth and Engage plans.</p>
                <vs-button v-if="upgradeAllowed" class="w-full" @click="$router.push('/dash/settings/plan')">See Plans</vs-button>
                <p v-else class="mt-4 text-dark">Ask the account owner to upgrade to unlock the Developer API.</p>
              </vx-card>
          </div>
        </div>
    </div>
  </div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data () {
    return {
      setupData: false
    }
  },
  computed: {
    disabled () {

      if (this.$store.getters['dash/agency']) return false

      let allowAutomationOverride = typeof this.$store.state.dash.viewData.business.allowAutomation !== 'undefined' ? this.$store.state.dash.viewData.business.allowAutomation : false
      if (allowAutomationOverride) return false
      if (this.$store.getters['dash/subscription'].isTrial) return true
      return this.$store.getters['dash/subscription'].plan === '1m' || this.$store.getters['dash/subscription'].plan === '1y'
    },
    disabledMessage () {
      if (!this.disabled) return false
      //PRICING 2026: automation is available on all current plans (automated invites
      //draw from your monthly invite quota) — only the legacy entry plans are gated
      return 'Automation isn\'t available on your current plan. Upgrade to unlock it — automated invites simply use your monthly invite quota.'
    },
    //PRICING 2026: Developer API card gated on the resolved plan's limits.devAPI
    //(false on Free + Learn). Separate from the automation disabled logic above.
    devAPIAllowed () {
      return !!this.$store.getters['dash/planResolved'].limits.devAPI
    },
    //hide the upgrade CTA for collaborators and agency-managed accounts
    upgradeAllowed () {
      if (this.$store.getters['dash/isCollaborator']) return false
      return this.$store.state.dash.viewData.business.upgradeCTAVisible !== false
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
